<template>
  <b-card>
    <client-edit-account
      v-if="loader === false"
      class="mt-2 pt-75"
      :user-data="userData"
      :form-data="formData"
    />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { ref/* , onUnmounted */ } from '@vue/composition-api'
import store from '@/store'
import router from '@/router'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ClientEditAccount from './ClientEditAccount.vue'
import userStoreModule from '../clientStoreModule'

export default {
  components: {
    BCard,
    ClientEditAccount,
  },
  data() {
    return {
      loader: true,
      busy: false,
      userData: ref(null),
      formData: ref(null),
      billing_address: {
        road_name: null,
        house_number: null,
        place: null,
        zip_code: null,
        city: null,
        country_id: null,
      },
    }
  },
  created() {
    // const userData = ref(null)
    const USER_APP_STORE_MODULE_NAME = 'app-client'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule)

    store.dispatch('app-client/fetchClient', { id: router.currentRoute.params.id })
      .then(response => {
        this.userData = response.data.data
        this.userData.bankBranchNo = this.userData.bank_branch_no
        this.userData.bankAccountNo = this.userData.bank_account_no
        this.userData.swiftCode = this.userData.swift_code
        // eslint-disable-next-line no-unneeded-ternary
        this.userData.vat_exempted = this.userData.vat_exempted === 1 ? true : false

        if (!this.userData.billing_address || this.userData.billing_address.length === 0) {
          this.userData.billing_address = this.billing_address
        }
        this.formData = { ...response.data }
        this.loader = false
      })
      .catch(error => {
        if (error.response.status === 404) {
          this.userData = undefined
        }
        if (error.response.status === 422) {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              icon: 'CoffeeIcon',
              variant: 'danger',
              text: error.response.data.message,
            },
          })
          this.$router.push('/clients/list')
        }
      })
  },
}
</script>

<style>

</style>
